import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import { reducer as reduxFormReducer } from "redux-form";
import thunk from "redux-thunk";
import axios from "axios";
import axiosMiddleware from "redux-axios-middleware";
import localForage from "localforage";
import {
  cryptoTableReducer,
  newOrderTableReducer,
  sidebarReducer,
  themeReducer,
  customizerReducer,
  drawerReducer,
  authReducer,
  commonReducer,
  accountReducer,
  geoReducer,
  testsReducer,
  networkReducer,
  notificationReducer
} from "../redux/reducers/index";

import {
  common_fetchCountries,
  COMMON_FETCH_COUNTRIES_SUCCESS,
  common_fetchData,
  COMMON_FETCH_DATA_SUCCESS
} from "../redux/actions/commonActions";

import { AUTH_SIGN_IN_SUCCESS } from "../redux/actions/authActions";

import createSagaMiddleware from "redux-saga";
import sagas from "./../redux/sagas/index";

const client = axios.create({
  //all axios can be used, shown in axios documentation
  baseURL: process.env.REACT_APP_API_URL, //'http://192.168.0.211:8001/api/v1/',
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": "es"
  }
});

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  cryptoTable: cryptoTableReducer,
  newOrder: newOrderTableReducer,
  customizer: customizerReducer,
  drawer: drawerReducer,
  auth: authReducer,
  common: commonReducer,
  account: accountReducer,
  geo: geoReducer,
  tests: testsReducer,
  network: networkReducer,
  notification: notificationReducer
});

//const store = (window.devToolsExtension ? window.devToolsExtension()(createStore) : createStore)(reducer, applyMiddleware(thunk));
// const DEVTOOLS = window.__REDUX_DEVTOOLS_EXTENSION__()

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const sagaMiddleware = createSagaMiddleware();

const enhancer = composeEnhancers(
  applyMiddleware(sagaMiddleware, thunk, axiosMiddleware(client))
);

const store = createStore(reducer, enhancer);
// Initiate inital requests

sagaMiddleware.run(sagas);

localForage.getItem("countries").then(response => {
  if (response !== null) {
    store.dispatch({ type: COMMON_FETCH_COUNTRIES_SUCCESS, payload: response });
  } else {
    store.dispatch(common_fetchCountries());
  }
});

localForage.getItem("common").then(response => {
  if (response !== null) {
    store.dispatch({ type: COMMON_FETCH_DATA_SUCCESS, payload: response });
  } else {
    store.dispatch(common_fetchData());
  }
});

localForage.getItem("account").then(response => {
  if (response !== null) {
    store.dispatch({ type: AUTH_SIGN_IN_SUCCESS, payload: response });
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/app/store.js